import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import ImageLibpixel from "./image-libpixel.js";
import { _ } from "../utils/i18n";
import { AnchorLink } from "gatsby-plugin-anchor-links";

const Post = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  border-radius: 0;
  width: calc((100% - 100px) / 4);
  height: 420px;
  background-color: #fff;
  margin: 20px 30px 20px 0;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  position: relative;
  border: 2px solid #dedede;
  border-radius: 4px;
  &:hover {
    background-color: #f8f8f8;
  }
  &:nth-child(4n + 4) {
    margin-right: 0;
    @media (max-width: 1024px) {
      margin-right: 10px;
    }
  }
  @media (max-width: 1024px) {
    width: calc((100% - 100px) / 3);
    margin: 10px;
  }
  @media (max-width: 810px) {
    width: 100%;
    margin: 20px 0;
    max-width: calc(100vw - 40px);
  }
`;
const PostLink = styled.div`
  width: 100%;
  position: relative;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  overflow: hidden;
`;
const Img = styled((props) => <ImageLibpixel {...props} />)`
  width: 100%;
  max-width: 100%;
  height: 260px;
  object-fit: cover;
  transition: transform 400ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`;
const HoverImg = styled.div`
  width: 100%;
  height: 260px;
  background-color: #06062b;
  opacity: 0;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  @media (max-width: 940px) {
    display: none;
  }
`;
const BtnContainer = styled.div`
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  opacity: 0;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  display: flex;
  width: 100%;
  height: 100%;
  flex-shrink: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 940px) {
    display: none;
  }
`;
const BaseButton = styled((props) => <AnchorLink {...props} />)`
  border-radius: 4px;
  width: 100%;
  max-width: 112px;
  height: 47px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border: 1px solid #fff;
  margin: 5px 0;
  &:hover {
    background-color: rgb(255 255 255 / 13%);
    color: #fff;
  }
  &.filled-btn {
    background-color: #f15e4e;
    border: 1px solid #f15e4e;
    &:hover {
      background-color: #f46d5e;
    }
  }
  &:visited {
    color: #fff !important;
  }
`;
const TextBox = styled.div`
  box-sizing: border-box;
  padding: 15px 20px 20px 20px;
  width: 100%;
  border-top: 0;
  flex-basis: auto;
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  @media (max-width: 1024px) {
    max-width: 354px;
  }
  @media (max-width: 415px) {
    max-width: none;
  }
`;
const TitleLink = styled((props) => <Link {...props} />)`
  width: 100%;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
const Title = styled.h2`
  font-weight: 600;
  font-size: 1.2rem;
  margin-top: 5px;
  margin-bottom: 15px;
  line-height: 1.4;
  @media (max-width: 940px) {
    padding-top: 0;
    height: auto;
    font-size: 1rem;
  }
`;
const Tags = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0;
  flex-flow: wrap;
`;
const PostDate = styled.p`
  margin-bottom: 0;
  font-size: 0.9rem;
  margin-right: 10px;
`;
const CatLink = styled((props) => <Link {...props} />)`
  width: 100%;
  color: #f15e4e;
  font-weight: 600;
  margin-bottom: 0;
  font-size: 0.9rem;
  @media (max-width: 940px) {
    max-width: 354px;
  }
  @media (max-width: 415px) {
    max-width: none;
  }
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
  &:visited {
    color: #f15e4e;
  }
`;
const Cat = styled.p`
  width: 100%;
  color: #f15e4e;
  font-weight: 600;
  margin-bottom: 0;
  font-size: 0.9rem;
  pointer-events: none;
  @media (max-width: 940px) {
    max-width: 354px;
  }
  @media (max-width: 415px) {
    max-width: none;
  }
`;
const CaseClient = styled.h3`
  color: #656565;
  font-weight: 600;
  text-transform: uppercase;
  margin: 0;
  font-size: 0.9rem;
`;
const BulletPoints = styled.p`
  font-size: 1rem;
  font-weight: 300;
  padding-right: 20px;
  margin-bottom: 5px;
  pointer-events: none;
`;

const months = [
  "januar",
  "februar",
  "mars",
  "april",
  "mai",
  "juni",
  "juli",
  "august",
  "september",
  "oktober",
  "november",
  "desember",
];

const BlogCard = ({
  showDate,
  date,
  caseClientLabel,
  imgUrl,
  link,
  innerStyle,
  title,
  linkCategory,
  category,
  bulletPoints,
  hasApplyBtn,
}) => {
  const publishedDate =
    showDate === true ? (
      <Tags>
        <PostDate itemProp="datePublished">
          {new Date(date).getDate()}. {months[new Date(date).getMonth()]}{" "}
          {new Date(date).getFullYear()}
        </PostDate>
      </Tags>
    ) : null;
  const caseClient = caseClientLabel ? (
    <CaseClient>{caseClientLabel}</CaseClient>
  ) : null;

  const hasBulletPoints = bulletPoints ? (
    <div
      style={{ width: "100%", display: "flex", justifyContent: "flex-start" }}
    >
      {bulletPoints.map((bulletPoint, i) => (
        <BulletPoints key={i}>&bull; {bulletPoint}</BulletPoints>
      ))}{" "}
    </div>
  ) : null;
  return (
    <Post
      itemScope
      itemType="http://schema.org/Blog"
      style={innerStyle}
      data-sal="slide-up"
      data-sal-delay="0"
      data-sal-duration="500"
      data-sal-easing="easeOutQuad"
      className="blogcard"
    >
      <PostLink>
        <Img
          itemProp="image"
          alt={_("post")}
          src={imgUrl}
          width={400}
          height={400}
          mode="crop"
        />
        <HoverImg className="hover-blog-img" />
        <BtnContainer className="blog-btn-container">
          {hasApplyBtn && (
            <BaseButton className="filled-btn" to={`${link}#career`}>
              {_("Søk nå")}
            </BaseButton>
          )}
          <BaseButton to={link}>{_("Les mer")}</BaseButton>
        </BtnContainer>
      </PostLink>
      <TextBox>
        {publishedDate}
        {caseClient}
        <TitleLink itemProp="url" to={link}>
          <Title itemProp="name">
            {title &&
              title
                .replace("&#038;", "&")
                .replace("&amp;", "&")
                .replace("&#8211;", "-")}
          </Title>
        </TitleLink>
        <Tags>
          {hasBulletPoints}
          <div id="category">
            {linkCategory ? (
              <CatLink itemProp="url" to={linkCategory}>
                {category &&
                  category.replace("&#038;", "&").replace("&amp;", "&")}
              </CatLink>
            ) : (
              <Cat>
                {category &&
                  category.replace("&#038;", "&").replace("&amp;", "&")}
              </Cat>
            )}
          </div>
        </Tags>
      </TextBox>
    </Post>
  );
};

BlogCard.propTypes = {
  caseClientLabel: PropTypes.string,
  link: PropTypes.string,
  linkCategory: PropTypes.string,
  imgUrl: PropTypes.string,
  date: PropTypes.string.isRequired,
  showDate: PropTypes.bool,
  title: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  innerStyle: PropTypes.object,
  casClientLabel: PropTypes.string,
  bulletPoints: PropTypes.array,
  hasApplyBtn: PropTypes.bool,
};

BlogCard.defaultProps = {
  showDate: true,
  link: "",
  imgUrl: "",
  innerStyle: undefined,
  caseClientLabel: "",
};

export default BlogCard;
